import { Component, type ErrorInfo, type ReactNode } from 'react';
import { Card } from './UI';

type Props = { children: ReactNode };
type State = { error?: Error };

export class ErrorBoundary extends Component<Props, State> {
  state: State = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[PFS runtime error]', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return <main className="auth-page">
      <Card>
        <h1>Something went wrong</h1>
        <p className="muted">{this.state.error.message}</p>
        <button className="btn primary wide" onClick={() => window.location.reload()}>Reload app</button>
      </Card>
    </main>;
  }
}
